<script>
    import { onMount } from "svelte";
    import { store } from "../../store.js";
    import Section from "../Common/Section.svelte";
    import LinkButton2 from "../Common/LinkButton2.svelte";
    import Typewriter from "svelte-typewriter";
    import sections from "./sections";

    let y;

</script>
<svelte:window bind:scrollY={y} />
<section style:position={"relative"}>
    <Section name="aboutAnchor" id="about" styles={sections[$store.type][$store.locale]['aboutAnchor'] || null} />

    <Section
        name="kct1"
        styles={sections[$store.type][$store.locale]['kct1'] || null}
    >
        <Typewriter cascade interval={50} cursor={false}>
            <h1 class="subtitle font-koho d-inline">Tickets to meet the new virtual world</h1>
            <h1 class="subtitle font-koho blink d-inline">_</h1>
        </Typewriter>
    </Section>

    <Section
        name="kct2"
        styles={sections[$store.type][$store.locale]['kct2'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="project-title theme-color">
                <strong>"Connect virtual and reality"</strong> 
            </div>
        {:else if $store.locale === 'kr'}
            <div class="project-title theme-color">
                <strong>"가상과 현실을 잇다"</strong> 
            </div>
        {:else if $store.locale === 'vn'}
            <div class="project-title theme-color">
                <strong>"Kết nối thực và ảo"</strong> 
            </div>
        {/if}
        
    </Section>

    <Section
        name="kct2-1"
        styles={sections[$store.type][$store.locale]['kct2-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="project-description">
                KCT is a membership token that can be used within Konnect World.
                Users can receive benefits over other payment methods when paying with KCT.
                In near future, a seperate stable coin just for payment will be used.
                You can increase your membership level by staking KCT. Konnect will initially
                be deployed on the Ethereum network and will integrate others to be multi-chain platform.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="project-description">
                KCT는 Konnect World에서 통용되는 멤버십 토큰입니다.
                사용자들은 더 큰 혜택을 위해 KCT를 결제수단으로 사용할 수 있습니다.
                뿐만 아니라 KCT 토큰을 스테이킹(예치)하여 멤버십 등급을 상향할 수도 있습니다.
                Konnect는 이더리움 플랫폼 기반에서 시작해 점진적으로 다중 플랫폼으로 확장할 계획입니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="project-description">
                KCT là một mã token dành cho thành viên được sử dụng trong Konnect World.
                Người dùng có thể sử dụng KCT như một phương thức thanh toán để có được những ưu đãi lớn hơn.
                Ngoài ra, bạn có thể tăng cấp bậc thành viên của mình bằng cách tích lũy token KCT.
                Konnect có kế hoạch bắt đầu với nền tảng cơ bản Ethereum và dần dần mở rộng ra nhiều nền tảng khác.
            </div>
        {/if}
        
    </Section>

    <Section
        name="kct3-1"
        styles={sections[$store.type][$store.locale]['kct3-1'] || null}

    >
        <div class="token-info">
            Token Name: <strong>KONNECT TOKEN</strong>
            Token Ticker: <strong>KCT</strong>
            Token Type: <strong>ERC-20</strong>
            Max Supply: <strong>10,000,000,000</strong>
        </div>
    </Section>

    <Section
        name="kct4"
        styles={sections[$store.type][$store.locale]['kct4'] || null}

    >
        
        {#if $store.locale === 'en'}
            <div class="project-title">
                <strong>KCT UTILITY</strong> 
            </div>
        {:else if $store.locale === 'kr'}
            <div class="project-title">
                <strong>KCT의 사용처와 실용성</strong> 
            </div>
        {:else if $store.locale === 'vn'}
            <div class="project-title">
                <strong>Công dụng và tính thực tiễn của KCT</strong> 
            </div>
        {/if}
    </Section>

    <Section
        name="kct4-1"
        styles={sections[$store.type][$store.locale]['kct4-1'] || null}

    >        
        {#if $store.locale === 'en'}
            <div class="project-description">
                KCT is a membership that can be used within the Konnect platform.
                When paying with KCT, variety of benefits and perks are given unlike paying with stable coins or fiat.
                In the near future, a separate stable coin exclusively for payment will be used.
            </div>
        {:else if $store.locale === 'kr'}           
            <div class="project-description">
                KCT는 Konnect World에서 제공하는 이커머스와 NFT 마켓에서 사용하실 수 있으며
                이 외에도 다양한 실물경제에서 사용하실 수 있습니다. KCT를 사용하시면 스테이블 코인이나
                일반 화폐, 카드 결제보다 더 큰 혜택을 받을 수 있습니다.
            </div>
        {:else if $store.locale === 'vn'}           
            <div class="project-description">
                KCT có thể được sử dụng trong thị trường thương mại điện tử và NFT do KONNECT WORLD cung cấp.
                Ngoài ra, nó có thể được sử dụng trong các nền kinh tế hàng hóa thực đa dạng. Nếu sử dụng KCT, bạn có thể nhận được 
                những ưu đãi lớn hơn so với stablecoin, tiền tệ thông thường hoặc phương thức thanh toán bằng thẻ.
            </div>
        {/if}
    </Section>

    <Section
        name="kct5"
        styles={sections[$store.type][$store.locale]['kct5'] || null}

    >        
        {#if $store.locale === 'en'}
            <div class="burning-title text-white">
                BURNING
            </div>
        {:else if $store.locale === 'kr'}           
            <div class="burning-title text-white">
                BURNING
            </div>
        {:else if $store.locale === 'vn'}           
            <div class="burning-title text-white">
                BURNING
            </div>
        {/if}
    </Section>

    <Section
        name="kct5-1"
        styles={sections[$store.type][$store.locale]['kct5-1'] || null}

    >
        {#if $store.locale === 'en'}
            <div class="burning-desc text-white">
                Konnect will burn tokens equivalent to
                1% of the sales of the B2C market every
                month or quarter, and the amount of burning will
                increase of decrease flexibly
                as the ecosystem expands in the future.
            </div>
        {:else if $store.locale === 'kr'}           
            <div class="burning-desc text-white">
                Konnect는 B2C 마켓 매출의 1% 상당의 토큰을
                매월 혹은 매 분기에 소각할 예정이며,
                소각량은 향후 생태계 확대에 따라
                유동적으로 증감됩니다.
            </div>
        {:else if $store.locale === 'vn'}           
            <div class="burning-desc text-center text-white">
                Konnect hoàn trả lợi nhuận cho chủ sở hữu mã token 
                bằng cách mỗi tháng đều đốt mã token KCT 
                với giá trị đồng đô la bằng 1% doanh số thị trường B2C. 
                Lượng đốt được cố định ở mức 1% khi bắt đầu dự án, 
                nhưng sẽ linh hoạt tăng lên khi hệ sinh thái mở rộng.
            </div>
        {/if}
    </Section>

    <Section name="membershipAnchor" id="membership" styles={sections[$store.type][$store.locale]['membershipAnchor'] || null} />

    <Section
        name="kct18"
        styles={sections[$store.type][$store.locale]['kct18'] || null}
    >
        <div class="section-title font-koho">
            MEMBERSHIP
        </div>
    </Section>

    <Section
        name="kct19"
        styles={sections[$store.type][$store.locale]['kct19'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="common-title">
                KCT or Konnect NFT Benefits of Being a Holder
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-title">
                KCT 또는 Konnect NFT 구매자들에 대한 혜택
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-title">
                Ưu đãi dành cho người mua KCT hoặc Konnect NFT
            </div>
        {/if}
    </Section>

    <Section
        name="kct20"
        styles={sections[$store.type][$store.locale]['kct20'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">
                Users are members of Konnect, not mere buyers. These members are given real benefits not virtual ones
                It will be a platform that grows together, where users benefit from membership rewards and perks.
                Konnect most effectively connects cryptocurrencies, finance, and real goods and services together.
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="common-desc">
                Konnect의 사용자들은 단순 구매자가 아닌 Konnect 생태계의 구성원으로 생각합니다.
                Konnect의 사용자들이 멤버십을 통해 여러 보상과 혜택을 얻으며 함께 성장해 나가는 플랫폼입니다.
                Konnect는 블록체인과 가상화폐를 통한 실물 재화 및 서비스를 가장 빠르고 투명하게 연결하겠습니다.
            </div>
        {:else if $store.locale === 'vn'} 
            <div class="common-desc">
                Konnect xem người dùng của mình là thành viên tạo nên hệ sinh thái Konnect, chứ không đơn thuần chỉ là người mua. 
                Vì vậy, chúng tôi muốn trở thành một nền tảng nơi người dùng Konnect có thể cùng nhau phát triển bằng cách gặt hái phần 
                thưởng và lợi ích thực tế trong cuộc sống thông qua những ưu đãi thành viên. Konnect sẽ kết nối hàng hóa và dịch vụ thực 
                tế với người dùng một cách nhanh nhất và minh bạch nhất thông qua blockchain và tiền ảo.
            </div>
        {/if}
    </Section>

    <Section
        name="kct21"
        styles={sections[$store.type][$store.locale]['kct21'] || null}
    >
        <div class="list-title">01</div>
    </Section>

    <Section
        name="kct21-1"
        styles={sections[$store.type][$store.locale]['kct21-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">
                Discounts according to level
                when using e-commerce
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="list-item">Konnect 이커머스(명품, 항공, 숙박 등) 이용시 멤버시 등급에 따른 할인 혜택</div>
        {:else if $store.locale === 'vn'} 
            <div class="list-item">Giảm giá và các ưu đãi bổ sung khác theo cấp bậc thành viên trong nền tảng thương mại điện tử Konnect (hàng hiệu, vé máy bay, khách sạn, ...)</div>

        {/if}
    </Section>

    <Section
        name="kct22"
        styles={sections[$store.type][$store.locale]['kct22'] || null}
    >
        <div class="list-title">02</div>
    </Section>

    <Section
        name="kct22-1"
        styles={sections[$store.type][$store.locale]['kct22-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">
                Separate fee discount
                when using NFT Marketplace
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="list-item">NFT Marketplace 사용시 멤버십 등급에 따른 할인 혜택</div>
        {:else if $store.locale === 'vn'} 
            <div class="list-item">Giảm giá và các ưu đãi bổ sung khác theo cấp bậc thành viên trên thị trường NFT</div>
        {/if}
    </Section>

    <Section
        name="kct23"
        styles={sections[$store.type][$store.locale]['kct23'] || null}
    >
        <div class="list-title">03</div>
    </Section>

    <Section
        name="kct23-1"
        styles={sections[$store.type][$store.locale]['kct23-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">
                When staking for chosen period,
                payback when issuing and using a card
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="list-item">KCT를 선택한 기간동안 스테이킹(예금) 시, 환급 가능한 멤버십 카드 발급</div>
        {:else if $store.locale === 'vn'} 
            <div class="list-item">Cấp thẻ thành viên KCT payback khi tích lũy KCT trong thời gian đã chọn</div>
        {/if}
    </Section>

    <Section
        name="kct24"
        styles={sections[$store.type][$store.locale]['kct24'] || null}
    >
        <div class="list-title">04</div>
    </Section>

    <Section
        name="kct24-1"
        styles={sections[$store.type][$store.locale]['kct24-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">
                Limited NFT and Mystery Box
                Purchase Opportunities
            </div>
        {:else if $store.locale === 'kr'} 
            <div class="list-item">한정판 NFT와 미스테리 박스 구매 기회</div>
        {:else if $store.locale === 'vn'} 
            <div class="list-item">Cơ hội mua NFT và Mystery Box phiên bản giới hạn </div>
        {/if}
    </Section>

    <Section
        name="kct25"
        styles={sections[$store.type][$store.locale]['kct25'] || null}
    >
        <div class="list-title">05</div>
    </Section>

    <Section
        name="kct25-1"
        styles={sections[$store.type][$store.locale]['kct25-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">Rewards according to the amount of KCT staking</div>
        {:else if $store.locale === 'kr'} 
            <div class="list-item">KCT 스테이킹(예금)에 따른 보상</div>
        {:else if $store.locale === 'vn'} 
            <div class="list-item">Mỗi thành viên được hưởng ưu đãi và phần thưởng theo số lượng  KCT tích lũy</div>

        {/if}
    </Section>

    <Section
        name="kct26"
        styles={sections[$store.type][$store.locale]['kct26'] || null}
    >
        <div class="section-title font-koho">
            MEMBERSHIP LEVEL
        </div>
    </Section>

    <Section
        name="kct27"
        styles={sections[$store.type][$store.locale]['kct27'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="section-subtitle">
                After chosen period of staking process, Konnect membership will be awarded.
            </div>
        {:else if $store.locale === 'kr'}             
            <div class="section-subtitle">
                최소 요구 수량 이상의 KCT 토큰을 스테이킹하고 필요한 인증절차를 완료하면 멤버십 등급이 부여됩니다.
            </div>
        {:else if $store.locale === 'vn'}             
            <div class="section-subtitle">
                cấp bậc thành viên sẽ được xác định sau khi đạt số lượng KCT token tích lũy  tối thiểu theo yêu cầu và hoàn tất quá trình xác thực cần thiết.
            </div>
        {/if}
    </Section>

    <Section
        name="kct28"
        styles={sections[$store.type][$store.locale]['kct28'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="section-subdesc">
                - Discounts benefits upon E-commerce
                - Commission & transaction fee discounts at NFT Marketplace
                - Opportunity to purchase limited NFTs & Mystery box sales
                - Card rewards (after chosen period of staking process is completed)
            </div>
        {:else if $store.locale === 'kr'}
            <div class="section-subdesc">
                - 멤버십 등급에 따른 입찰 티켓
                - 멤버십 등급에 따른 NFT 등급 상향 확률 부여
                - 스테이킹 리워드 제공
                - 결제 금액에 따른 KCT 리워드 제공
            </div>
        {:else if $store.locale === 'vn'}
            <div class="section-subdesc">
                - Vé đấu thầu theo cấp bậc thành viên
                - Xác suất tăng cấp độ NFT theo cấp bậc thành viên
                - Cung cấp giải thưởng tích lũy
                - Cung cấp KCT đào được theo số tiền thanh toán
            </div>
        {/if}
    </Section>

    <Section name="stakingAnchor" id="staking" styles={sections[$store.type][$store.locale]['stakingAnchor'] || null} />

    <Section
        name="kct29"
        styles={sections[$store.type][$store.locale]['kct29'] || null}
    >
        <div class="section-title font-koho">
            STAKING
        </div>
    </Section>

    <Section
        name="kct29-2"
        styles={sections[$store.type][$store.locale]['kct29-2'] || null}
    >
        <div class="section-title font-koho">
            KCT ALLOCATION
        </div>
    </Section>

    <Section
        name="kct29-3"
        styles={sections[$store.type][$store.locale]['kct29-3'] || null}
    >
        <div class="section-title font-koho">
            CARD
        </div>
    </Section>

    <Section name="walletAnchor" id="wallet" styles={sections[$store.type][$store.locale]['walletAnchor'] || null} />

    <!-- <Section
        name="kct30"
        styles={sections[$store.type][$store.locale]['kct30'] || null}
    >
        <div class="section-title font-koho">
            WALLET
        </div>
    </Section>

    <Section
        name="kct30-1"
        styles={sections[$store.type][$store.locale]['kct30-1'] || null}
    >
        {#if $store.locale === 'en'}            
            <div class="project-description">
                Konnect Wallet is the cohesive one-way solution providing all the features and benefits of a Payment Gateway(PG) and
                a personal wallet. Konnect's solution of PG integeration and payment fully abides by KYC and AML policy and regulations
                around the world. Konnect commerce and Konnect NFT Marketplace users are provided with a wallet and vendor POS
                system included in K-bridge's proprietary payment gateway (PG).
                <br><br>
                The point is that the current online payment system has been redesigned via blockchain.
                Through blockchain, users receive more convenience functions such as staking,
                P2P settlement, and automatic refunds as well as payment services.
            </div>
        {:else if $store.locale === 'kr'}            
            <div class="project-description">
                Konnect Wallet은 블록체인의 결제 게이트웨이(PG)와 사용자 개인 지갑(Wallet)의
                두 가지 기능을 하나의 시스템으로 관리하는 일원화가 특장점입니다.
                PG와 결제를 통합한 솔루션은 세계 각국에서 요구하는 KYC와 AML의 정책 조건을 충족합니다.
                <br><br>
                주목할 부분은 현 온라인 지불 시스템을 블록체인 기반으로 재설계 했다는 점입니다.
                이를 통해 사용자는 결제 서비스는 물론 스테이킹과 P2P 정산, 자동 환불같은 더 편리한
                기능과 확장된 혜택을 제공받을 수 있습니다.
            </div>
        {:else if $store.locale === 'vn'}            
            <div class="project-description text-center">
                Ưu điểm của Konnect Wallet là thống nhất quản lý hai chức năng cổng thanh toán blockchain (PG) 
                và ví cá nhân (Wallet) của người dùng thành một hệ thống.
                Giải pháp tích hợp PG và thanh toán đáp ứng được các điều kiện chính sách của KYC và AML theo yêu cầu của các quốc gia trên thế giới.
            </div>
        {/if}
    </Section> -->

    <Section name="cardAnchor" id="card" styles={sections[$store.type][$store.locale]['cardAnchor'] || null} />

    <!-- <Section
        name="kct31"
        styles={sections[$store.type][$store.locale]['kct31'] || null}
    >
        <div class="section-title font-koho">
            CARD
        </div>
    </Section> -->

    <Section
        name="kct31-1"
        styles={sections[$store.type][$store.locale]['kct31-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="project-description">
                Users who have been issued a Konnect Card can enjoy exclusive benefits and perks in the expanded Konnect ecosystem.
                Pre-paid cards will be issued with strategic partners and card issuers. Credit cards and debit cards are also 
                planned to be the options in the future.
                <br><br>
                Users who stake KCT over chosen period can issue a card that corresponds to the membership level.
                When paying with the Konnect Card, benefits and perks associated with the membership level are given.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="project-description">
                Konnect Card를 발급받은 사용자는 Konnect 플랫폼의 확장 생태계에서 더 많은 혜택을 누리며 사용할 수 있습니다.
                카드 발급사와의 제휴를 통한 선불 카드를 제공될 예정이며, 향후 체크카드와 신용카드 발급도 지원할 예정입니다.
                <br><br>
                사용자가 KCT를 선택한 기간 이상 스테이킹 할 시 멤버십 등급과 동일한 카드 발급이 가능하며
                해당 카드로 결제시 등급에 맞는 혜택을 받을 수 있습니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="project-description text-center">
                Người dùng đã được cấp Konnect Card có thể tận hưởng và sử dụng nhiều ưu đãi hơn trong hệ sinh thái mở rộng của nền tảng Konnect.
                Thẻ này được cung cấp dưới dạng thẻ trả trước thông qua quan hệ đối tác với công ty phát hành thẻ và chúng tôi cũng có kế hoạch 
                hỗ trợ phát hành thẻ ghi nợ và thẻ tín dụng trong tương lai.
            </div>
        {/if}
    </Section>

    <Section
        name="kct32"
        styles={sections[$store.type][$store.locale]['kct32'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="card-title font-koho">
                APPLY
            </div>
        {:else if $store.locale === 'kr'}
            <div class="card-title font-koho">
                신청
            </div>
        {:else if $store.locale === 'vn'}
            <div class="card-title font-koho">
                Đăng ký
            </div>
        {/if}
    </Section>

    <Section
        name="kct32-1"
        styles={sections[$store.type][$store.locale]['kct32-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="card-desc">
                Users staked KCT over chosen
                periods can issue cards
                according to the membership
                level. The corresponding
                benefits are given when paying
                with the card. Apply for
                issuance after KYC verification
                within the wallet.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="card-desc">
                사용자들은 Konnect Card를
                발급받아 Konnect 플랫폼
                내/외부에서 사용할 수 있으며
                그에 따른 혜택을 받을 수
                있습니다.
            </div>            
        {:else if $store.locale === 'vn'}
            <div class="card-desc">
                Người dùng đăng ký phát hành 
                thẻ Konect Card có thể sử 
                dụng thẻ trong/ngoài nền tảng 
                Konect đồng thời có thể nhận 
                được các ưu đãi quyền lợi 
                tùy theo cấp độ thành viên.
            </div>
        {/if}
    </Section>

    <Section
        name="kct33"
        styles={sections[$store.type][$store.locale]['kct33'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="card-title font-koho">
                REWARD
            </div>
        {:else if $store.locale === 'kr'}
            <div class="card-title font-koho">
                보상
            </div>
        {:else if $store.locale === 'vn'}
            <div class="card-title font-koho">
                Quyền lợi
            </div>
        {/if}
    </Section>

    <Section
        name="kct33-1"
        styles={sections[$store.type][$store.locale]['kct33-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="card-desc">
                Rewards on card payments are
                distributed in KCT. Reward
                distribution is immediate after
                the slip purchasement, and the
                reward limit is reset monthly.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="card-desc">
                Konnect 카드는 카드사와 제휴를
                통해 발급되는 선불 카드이며
                추후 신용카드, 체크카드도 지원할
                예정입니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="card-desc">
                Thẻ Konnect là thẻ trả trước được 
                phát hành thông qua sự hợp tác 
                với công ty tín dụng, ngoài ra 
                thẻ tín dụng và thẻ ghi nợ cũng 
                sẽ được hỗ trợ trong tương lai.
            </div>
        {/if}
    </Section>

    <Section
        name="kct34"
        styles={sections[$store.type][$store.locale]['kct34'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="card-title font-koho">
                CHARGE
            </div>
        {:else if $store.locale === 'kr'}
            <div class="card-title font-koho">
                충전
            </div>
        {:else if $store.locale === 'vn'}
            <div class="card-title font-koho">
                Nạp vào
            </div>
        {/if}
    </Section>

    <Section
        name="kct34-1"
        styles={sections[$store.type][$store.locale]['kct34-1'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="card-desc">
                Cards must be charged after
                being issued to be used.
                You can charge your card
                with multiple methods such as
                fiat, crypto, credit card, and
                debit card in your wallet.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="card-desc">
                사용자들은 KCT를 선택한 기간 이상
                스테이킹 할 시에 해당 등급에
                맞는 카드를 발급받을 수 있습니다.
                또한 카드 사용시 멤버십 등급에 맞는
                보상을 받을 수 있습니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="card-desc">
                Khi người dùng tích lũy KCT lâu hơn 
                khoảng thời gian đã chọn thì có 
                thể được cấp một thẻ phù hợp với 
                cấp độ thành viên tương ứng. 
                Ngoài ra khi sử dụng thẻ có thể 
                nhận được phần quà phù hợp với cấp 
                độ thành viên.
            </div>
        {/if}
    </Section>

</section>

<style>
    .slogan {
        margin: 0 !important;
        font-weight: 700;
        letter-spacing: -1px;
        font-size: 3.5vw;
        text-shadow: 1px 2px 2px black;
    }

    .subtitle {
        font-size: 10vw;
    }

    .project-title {
        font-size: 5vw;
        letter-spacing: -1px;
    }

    .project-description {
        font-size: 3.5vw;
        line-height: 5.5vw;
        /* white-space: pre-line; */
        letter-spacing: -1px;
    }

    .token-info {
        font-size: 4vw;
        font-family: 'sandoll-gothicneo1';
        font-weight: 500;
        white-space: pre-line;
    }

    .section-title {
        font-size: 6vw;
        font-weight: 600;
    }

    .section-subtitle {
        font-size: 4vw;
        font-weight: 600;
    }

    .section-subdesc {
        line-height: 7vw;
        font-size: 4vw;
        font-weight: 500;
        white-space: pre-line;
    }

    .burning-title {
        font-size: 4vw;
        font-family: 'sandoll-gothicneo1';
        text-shadow: 0 0 2px #fff, 0 0 2px #fff, 0 0 2px #ffffff, 0 0 2px #ffffff, 0 0 2px #ffffff, 0 0 2px #ffffff, 0 0 2px #ffffff;
        font-weight: 800;
    }

    .burning-desc {
        font-size: 3vw;
        font-family: 'sandoll-gothicneo1';
        font-weight: 500;
        line-height: 5vw;
    }

    .common-title {
        font-size: 4vw;
        font-family: 'sandoll-gothicneo1';
        font-weight: 400;
        letter-spacing: -0.5px;
    }

    .common-desc {
        font-size: 4vw;
        font-family: 'sandoll-gothicneo1';
        letter-spacing: -0.5px;
        line-height: 6vw;
        color: #6d6e6e;
    }

    .card-title {
        font-size: 6vw;
        font-weight: 600;
    }

    .card-desc {
        font-size: 3.5vw;
        line-height: 6vw;
    }

    .list-title {
        font-size: 4vw;
        font-weight: bold;
        font-family: 'sandoll-gothicneo1';
    }

    .list-item {
        /* white-space: pre-line; */
        font-size: 4vw;
        letter-spacing: -2px;
        font-family: 'sandoll-gothicneo1';
    }

    .menu {
        display: inline-block;
        position: fixed;
        left: 0;
        width: 350px;
        top: 60px;
        height: 500px;
    }

    .menu ul {
        list-style-type: none;
        padding-left: 87px;
        margin-top: 65px;
    }

    .menu ul::before{
        content: '';
        display: block;
        width: 50%;
        border: 1px solid black;
        margin-bottom: 20px;
    }

    .menu ul li {
        font-size: 1.2vw;
        margin-bottom: 10px;
        letter-spacing: -1px;
    }

    .menu ul li a {
        color: inherit;
        text-decoration: inherit;
    }

    :global(.menu ul li a.active) {
        font-weight: bold;
    }

    .menu ul li a:active, .menu ul li a:focus {
        font-weight: bold;
        outline: none;
        box-shadow: none;
    }

</style>
